<template>
  <div class="hzc-login">
    <div class="head">
      <div class="img-box">
        <img src="../assets/home/logo.png" alt="">
      </div>
    </div>
    <div class="bgc">
      <div class="box">
        <div class="left-bgc">
          <p>商品研究大数据</p>
          <div>实时的商品资讯</div>
        </div>
        <div class="content">
          <img src="../assets/images/waiconfirm.png" class="wai-confirm" alt="">
          <p>欢迎登录</p>
          <label style="position: relative">
            <el-input type="text" maxlength="14" clearable v-model="loginForm.username"></el-input>
            <!--            <img src="../assets/images/confirm.png" class="confirm" @click="emptyInput" alt="">-->
          </label>
          <label>
            <el-input style="margin-bottom: 4px;margin-top: 20px;" clearable type="password" maxlength="20"
                      v-model="loginForm.password"
                      @keyup.enter.native="handleLogin"></el-input>
          </label>
          <div class="login-tips" v-if="tipsHidden">用户名或密码错误！</div>
          <el-button class="login-btn" @click.native.prevent="handleLogin">登录</el-button>
          <div class="passDiv">
            <el-checkbox v-model="loginForm.rememberMe"></el-checkbox>
            记住密码
            <span @click="goChangePassword">忘记密码?</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import store from '../store'
import Cookies from "js-cookie";
import {encrypt, decrypt, encryptByDES} from '@/utils/jsencrypt'

export default {
  name: "login",
  data() {
    return {
      loginForm: {
        username: "",
        password: "",
        rememberMe: true,
      },
      loading: false,
      tipsHidden: false,
      redirect: undefined
    }
  },
  created() {
    this.getCookie();
  },
  watch: {
    $route: {
      handler: function (route) {
        let temp = route.query && route.query.redirect;
        if (route.query.flag) {
          this.redirect = temp + '&flag=' + route.query.flag;
          if (route.query.other) {
            this.redirect = this.redirect + '&other=' + route.query.other;
          }
          console.log(route.query)
        } else {
          this.redirect = temp;
        }
      },
      immediate: true
    }
  },
  methods: {
    /**
     * 清空输入框
     */
    emptyInput() {
      this.loginForm['username'] = '';
      this.loginForm['password'] = '';
    },
    /**
     * 获取本地cookie
     */
    getCookie() {
      const username = Cookies.get("username");
      const password = Cookies.get("password");
      const rememberMe = Cookies.get('rememberMe')
      this.loginForm = {
        username: username === undefined ? this.loginForm.username : username,
        password: password === undefined ? this.loginForm.password : password,
        rememberMe: rememberMe === undefined ? false : Boolean(rememberMe)
      };
    },
    /**
     * 判断是否输入账号密码
     */
    valid() {
      if (this.loginForm['username'] !== '' && this.loginForm['password'] !== '') {
        return true;
      } else {
        return false;
      }
    },
    /**
     * 前往修改密码
     */
    goChangePassword() {
      window.openUrl('https://www.risuncloud.com/find-pwd');
    },
    /**
     * 登陆
     */
    handleLogin() {
      if (this.valid) {
        this.loading = true;
        this.tipsHidden = false;
        const data = JSON.parse(JSON.stringify(this.loginForm))
        data['password'] = encryptByDES(data.password)
        if (this.loginForm.rememberMe) {
          Cookies.set("username", this.loginForm.username, {expires: 30});
          Cookies.set("password", this.loginForm.password, {expires: 30});
          Cookies.set('rememberMe', this.loginForm.rememberMe, {expires: 30});
        } else {
          Cookies.remove("username");
          Cookies.remove("password");
          Cookies.remove('rememberMe');
        }
        this.$store.dispatch("Login", data).then(() => {
          store.dispatch('GetInfo').then(() => {
            this.$router.push({path: this.redirect || "/"}).catch(() => {
            });
          }).catch(err => {
            console.log(err)
          })
          this.$emit('loginTrue', false)
        }).catch(() => {
          this.loading = false;
          this.tipsHidden = true;
        });
      }
    }
  }
}
</script>

<style scoped lang="less">
.hzc-login {

  .head {
    height: 80px;
    width: 100%;
    background-color: #fff;
    line-height: 100px;

    .img-box {
      width: 1200px;
      margin: 0 auto;

      img {
        //margin-left: 360px;
        width: 420px;
      }
    }
  }

  .bgc {
    background-image: url('../assets/images/login-bgc.png');
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    min-width: 1000px;
    z-index: -10;
    zoom: 1;
    background-color: #fff;
    background-repeat: no-repeat;
    background-size: cover;
    -webkit-background-size: cover;
    -o-background-size: cover;
    background-position: center 0;

    .box {
      width: 797px;
      height: 452px;
      background: #FFFFFF;
      box-shadow: 0px 2px 4px 0px rgba(0, 0, 0, 0.3);
      border-radius: 4px;
      position: absolute;
      top: 50%;
      margin-top: -225px;
      left: 50%;
      margin-left: -400px;

      .left-bgc {
        display: inline-block;
        width: 399px;
        height: 438px;
        margin-left: -1px;
        background-image: url('../assets/images/login-left.png');
        background-size: 100% 100%;
        padding-left: 39px;
        padding-top: 30px;

        p {
          width: 140px;
          height: 28px;
          font-size: 20px;
          font-family: PingFangSC-Medium, PingFang SC;
          font-weight: 500;
          color: #FFFFFF;
          line-height: 28px;
        }

        div {
          width: 147px;
          height: 20px;
          font-size: 14px;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          color: #FFFFFF;
          line-height: 20px;
          letter-spacing: 7px;
        }
      }

      .content {
        display: inline-block;
        width: 280px;
        vertical-align: top;
        height: 388px;
        background: #FFFFFF;
        border-radius: 4px;
        padding: 40px;
        position: relative;

        .wai-confirm {
          position: absolute;
          right: 16px;
          top: 16px;
          cursor: pointer;
        }

        .confirm {
          position: absolute;
          top: 2px;
          left: 255px;
          cursor: pointer;
        }

        p {
          margin-top: 26px;
          height: 33px;
          font-size: 24px;
          font-family: PingFangSC-Medium, PingFang SC;
          font-weight: 500;
          color: #222222;
          line-height: 33px;
          margin-bottom: 32px;
        }

        input {
          width: 260px;
          height: 36px;
          background: #F8F8F8;
          border-radius: 4px;
          border: 1px solid #CCCCCC;
          margin-bottom: 24px;
          outline: none;
          padding: 0 10px;
        }

        .login-tips {
          color: #AC1307;
        }

        .login-btn {
          width: 280px;
          height: 40px;
          background: #D3131A;
          border-radius: 4px;
          margin-top: 16px;
          color: #fff;
          text-align: center;
          cursor: pointer;
          border: none;
        }

        .passDiv {
          margin-top: 8px;

          .el-checkbox {
            margin-right: 4px;
          }

          span {
            float: right;
            color: #D3131A;
            cursor: pointer;
          }
        }
      }
    }


  }
}
</style>
